export const SET_CLIENTSTATUS_LIST = 'SET_CLIENTSTATUS_LIST'


